export default __webpack_public_path__ + "static/media/main-banner-desktop.144bee2f.png";